var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0H21C22.6563 0.00130969 23.9987 1.34369 24 3V21C23.9987 22.6563 22.6563 23.9987 21 24H3C1.34369 23.9987 0.00130969 22.6563 0 21V3C0.00130969 1.34369 1.34369 0.00130969 3 0ZM17.9665 17.2597C18.0585 16.9145 17.9587 16.5465 17.705 16.295L13.415 12L17.705 7.705C18.0944 7.31564 18.0944 6.68436 17.705 6.295C17.3156 5.90564 16.6844 5.90564 16.295 6.295L12 10.585L7.705 6.295C7.31564 5.90564 6.68436 5.90564 6.295 6.295C5.90564 6.68436 5.90564 7.31564 6.295 7.705L10.585 12L6.295 16.295C5.90564 16.6844 5.90564 17.3156 6.295 17.705C6.68436 18.0944 7.31564 18.0944 7.705 17.705L12 13.415L16.295 17.705C16.5465 17.9587 16.9145 18.0585 17.2597 17.9665C17.6049 17.8745 17.8745 17.6049 17.9665 17.2597Z",
    fill: "#FF4300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.a8466e8e6a8eff6af3bd19edf0909222.svg";
export { ForwardRef as ReactComponent };